module.exports = __webpack_public_path__ + "img/Icone_168.c52be603.png";